export default __webpack_public_path__ + "static/media/laptop.f8ac74e3.png";